import { GRAY, GREEN, RED } from '@src/sld/components/Shared';
import { ReactElement } from 'react';
import { DataPointWithValue } from '@src/types/DataPoint';
type labelProps = {
  label: string;
  xCoordinate: number;
  yCoordinate: number;
};

type BreakerBasicProps = {
  labels: labelProps[];
  translateXCoordinate: number;
  translateYCoordinate: number;
  dataPointsWithValues?: DataPointWithValue[] | undefined;
  defaultHot?: boolean;
};

function BreakerBasic({
  labels,
  translateXCoordinate,
  translateYCoordinate,
  dataPointsWithValues,
  defaultHot,
}: BreakerBasicProps): ReactElement {
  const setFillColor = (v: string | number | null | undefined) => {
    if (v === null || v === undefined) {
      return GRAY;
    }

    return v !== 0 ? RED : GREEN;
  };

  return (
    <>
      <g
        transform={`translate(${translateXCoordinate} ${translateYCoordinate})`}
      >
        <rect
          y={1}
          x={3}
          width='20'
          height='20'
          fill={
            dataPointsWithValues?.[0]?.value !== undefined
              ? setFillColor(dataPointsWithValues?.[0]?.value)
              : defaultHot
                ? RED
                : setFillColor(dataPointsWithValues?.[0]?.value)
          }
          strokeWidth={0.5}
        />
        {labels.length > 0 && (
          <>
            <text
              x={labels[0].xCoordinate}
              y={labels[0].yCoordinate}
              fontSize={8}
              fill='white'
              stroke='white'
              strokeWidth={0.2}
            >
              {labels[0].label}
            </text>
          </>
        )}

        {labels.length > 1 && (
          <text
            x={labels[1].xCoordinate}
            y={labels[1].yCoordinate}
            fontSize={8}
            fill='white'
            stroke='white'
            strokeWidth={0.2}
          >
            {labels[1].label}
          </text>
        )}
      </g>
    </>
  );
}

export default BreakerBasic;
